<template>
    <div class="container">
        <div class="text-center">
            <Loading class="mt-3" v-if="loading && isAuthenticated"/>

            <Login v-if="!isAuthenticated"></Login>

            <div v-else-if="getSummaryList.length>0" class="table-container mt-0 mx-auto col-md-6 table-responsive-sm">
                <h5>VERVOERSDOCUMENT {{getSummaryList[0].TripName}}</h5>
                <div class="row">
                    <div class="col-6 text-left">
                        <p><b class="mr-5">KENTEN</b> 41BKV9</p>
                    </div>
                    <div class="col-6 text-left">
                        <p><b class="mr-5">DATUM</b> {{currentDate()}}</p>
                    </div>
                </div>
               
                <table class="table table-sm">
                    <tbody class="text-right border-top-0">
                        <!-- KOOIEN EN KRATEN section -->
                        <tr>
                            <th colspan="2" class="text-left">KOOIEN EN KRATEN</th>
                            <th>Eigen gewicht</th>
                            <th>Aantal</th>
                            <th>Totaal gewicht</th>
                        </tr>
                        <tr v-for="(item, index) in getCompartmentList" :key="index">
                            <td colspan="2" class="text-left">{{item.CompartmentName}}</td>
                            <td>{{item.WeightCompartment}}</td>
                            <td>{{item.QuantityComp}}</td>
                            <td>{{item.TotalWeightComp}}</td>
                        </tr>
                        <tr>
                            <td colspan="2"></td>
                            <td></td>
                            <td>{{getCompartmentListTotalQuantity}}</td>
                            <td>{{getCompartmentListTotalWeight}}</td>
                        </tr>
                        <!-- Soort section -->
                        <tr>
                            <th colspan="2" class="text-left">Soort</th>
                            <th>Aantal</th>
                            <th>Gewicht</th>
                            <th>Bruto KG Gas</th>
                        </tr>
                        <tr v-for="(item, index) in getSpeciesList" :key="index">
                            <td colspan="2" class="text-left">{{item.Type}}</td>
                            <td>{{item.Quentity}}</td>
                            <td>{{item.Weight}}</td>
                            <td>{{item.Bruto}}</td>
                        </tr>
                        <tr>
                            <th colspan="3" class="text-left">Total gewicht lading</th>
                            <th>{{getSpeciesListTotalWeight}}</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </tbody>

                    <div class="empty">

                    </div>
                    
                    <tbody class="border-top-0 summary-list" v-for="(summary, index) in getSummaryList" :key=index>
                            <tr class="no-border">
                                <th class="border-right border-left">Aantal</th>
                                <th class="border-right border-left" colspan="4">Product</th>
                            </tr>
                            <tr class="no-border">
                                <td class="border-right border-left">{{summary.Quantity}}</td>
                                <td class="border-right border-left" colspan="4">{{summary.ProductName}}</td>
                            </tr>
                            <tr class="no-border">
                                <th class="border-right border-left">Mengsel/Klasse</th>
                                <th class="border-right border-left">Inhoud</th>
                                <th class="border-right border-left">Bruto kg gas</th>
                                <th class="border-right border-left">Embalage Gewicht</th>
                                <th class="border-right border-left">Fles+inhoud</th>
                            </tr>
                            <tr class="no-border">
                                <td class="border-right border-left">{{summary.ProductUnRemark}}</td>
                                <td class="border-right border-left">{{summary.VolumeBottle}}</td>
                                <td class="border-right border-left">{{summary.BrutoGas}}</td>
                                <td class="border-right border-left">{{summary.BottleWeight}}</td>
                                <td class="border-right border-left">{{(summary.BrutoGas + summary.Quantity * summary.BottleWeight).toFixed(2)}}</td>
                            </tr>
                    </tbody>
                </table>
            </div>
            <div class="text-center" v-else-if="isAuthenticated && !loading && (!getSummaryList  || getSummaryList.length<1)">
                <h5>{{$t('NoILTInfo')}}</h5>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { COMPARTMENTLIST_REQUEST } from "actions/compartmentList";
    import { SPECIESLIST_REQUEST } from "actions/speciesList";
    import { SUMMARYLIST_REQUEST } from "actions/summaryList";

    export default {
        name: "ListILT2",
        data() {
            return {
                
            };
        },
        watch: {
            isOnline: function (val) {
                if (val && this.isAuthenticated) {
                    this.$store.dispatch(COMPARTMENTLIST_REQUEST);
                    this.$store.dispatch(SPECIESLIST_REQUEST);
                    this.$store.dispatch(SUMMARYLIST_REQUEST);
                }
                if (!val)
                    this.$root.$children[0].$refs.requestToats.makeToast('warning', 'no internet connection', 'You are using app in offline mode');
            }
        },
        mounted() {
            if (this.isOnline && this.isAuthenticated) {
                this.$store.dispatch(COMPARTMENTLIST_REQUEST);
                this.$store.dispatch(SPECIESLIST_REQUEST);
                this.$store.dispatch(SUMMARYLIST_REQUEST);
            }
            if (!this.isOnline)
                this.$root.$children[0].$refs.requestToats.makeToast('warning', 'no internet connection', 'You are using app in offline mode');
        },
        computed: {
            ...mapGetters([
                "isAuthenticated",
                "authStatus",
                "getCompartmentListStatus",
                "getCompartmentList",
                "getCompartmentListTotalQuantity",
                "getCompartmentListTotalWeight",
                "getSpeciesListStatus",
                "getSpeciesList",
                "getSpeciesListTotalWeight",
                "getSummaryListStatus",
                "getSummaryList",
            ]),
            loading: function () {
                return this.authStatus === "loading" ||
                    this.getCompartmentListStatus === "loading" ||
                    this.getSpeciesListStatus === "loading" ||
                    this.getSummaryListStatus === "loading";
            }
        },
        methods: {
            currentDate() {
                const current = new Date();
                return current.getDate() + ' ' + (current.getMonth() + 1) + ' ' + current.getFullYear();
            }
        }
    };
</script>

<style>
    table, p {
        font-size: 12px;
    }
    .table-container {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
    .table>tbody>tr.no-border>td {
        border-top: none;
    }
    .text-left {
        text-align: left;
    }
    .text-right {
        text-align: right;
    }
    .empty {
        height: 30px;
    }
    .summary-list:nth-child(even) {
        background-color: #f2f2f2;
    }
    .summary-list:last-child tr:last-child td{
        border-bottom: 1px solid #dee2e6;
    }
</style>